import { setAuthorization, HTTP } from '../http';
import french from '../i18n/locales/fr.json';
import english from '../i18n/locales/en.json';
import customValidationEN from '../i18n/validation/en.json';
import customValidationFR from '../i18n/validation/fr.json';

import CreateIndex from '../pages/paraphers/create/index.vue';
import CreateAddParameters from '../pages/paraphers/create/AddParameters.vue';
import CreateAddSignatories from '../pages/paraphers/create/AddSignatories.vue';
import CreateAddDocuments from '../pages/paraphers/create/AddDocuments.vue';
import CreateAddSignatures from '../pages/paraphers/create/AddSignatures.vue';
import CreateSuccess from '../pages/paraphers/create/Success.vue';
import Edit from '../pages/signworkflows/edit.vue';
import GuestDetails from '../pages/signworkflows/guestDetails.vue';
import GuestSignworkflows from '../pages/signworkflows/guestSignworkflows.vue';
import Sign from '../pages/signworkflows/sign.vue';
import Signworkflows from '../pages/signworkflows/signworkflows.vue';
import ThirdPartySignworkflow from '../pages/signworkflows/thirdPartySignworkflow.vue';
import EdocSignSidenav from '../components/menu/EdocSignSidenav';
import AddSignatoriesDialog from '../pages/signatories/social/AddSignatoriesDialog';
import CreateSocialSignatory from '../pages/signatories/social/create';
import EditSocialSignatory from '../pages/signatories/social/edit';
import IndexSignatories from '../pages/signatories/social/index';
import AllTemplates from '../pages/templates/all';
import IndexTemplate from '../pages/templates/index';
import SignDialog from '../pages/signworkflows/dialog/signature/SignDialog';
import RefuseDialog from '../pages/signworkflows/dialog/refuseDialog';

import ModuleEdocSign from './store';
import routes from './routes';

export default {
  install(Vue, options) {
    // init axios instance with user sessions
    setAuthorization(options.session);

    options.store.registerModule('ModuleEdocSign', ModuleEdocSign);

    const Components = {
      CreateIndex,
      CreateAddParameters,
      CreateAddSignatories,
      CreateAddDocuments,
      CreateAddSignatures,
      CreateSuccess,
      Edit,
      GuestDetails,
      GuestSignworkflows,
      Sign,
      Signworkflows,
      ThirdPartySignworkflow,
      EdocSignSidenav,
      AddSignatoriesDialog,
      CreateSocialSignatory,
      EditSocialSignatory,
      IndexSignatories,
      AllTemplates,
      IndexTemplate,
      SignDialog,
      RefuseDialog,
    };

    Object.keys(Components)
      .forEach((name) => {
        Vue.component(name, Components[name]);
      });

    // module name and structure
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$moduleEdocsign = {
      name: 'ModuleEdocSign',
      routes,
      translations: {
        french: french.messages,
        english: english.messages,
        frenchCustomValidation: customValidationFR.messages,
        englishCustomValidation: customValidationEN.messages,
      },
      axiosInstances: [HTTP],
    };
  },
};
